import React, { useEffect } from 'react';
import Header from '../../layout/header/Header';
import Card from '../../components/card/Card';
import ModalCard from '../../components/modalCard/ModalCard';
import SearchBar from '../../layout/searchBar/SearchBar';
import Pagination from '../../components/pagination/Pagination';
import Loader from '../../components/loader/Loader';
import { SingleVideoItem } from '../../types/singleVideoType';
import { setLSData } from '../../utils/data';
import { useAppSelector, useAppDispatch } from '../../store/store';
import {
  updateModal,
  updatePagination,
  toggleModal,
  fetchCardsData,
  fetchModalCardData,
} from '../../store/apiPageReducer';

import './_homepage.scss';

export default function Homepage() {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state.apiPage);
  useEffect(() => {
    const { search, searchBarState, currPageToken } = state;
    dispatch(updateModal({ isModalLoaded: false, modalCard: [] }));
    const isSingleCard = false;
    dispatch(fetchCardsData({ search, isSingleCard, searchBarState, currPageToken }));
  }, [state.searchBarState, dispatch]);

  window.addEventListener('beforeunload', () => {
    setLSData('search', state.search);
  });

  const handleSearch = async (search: string) => {
    const { searchBarState, currPageToken } = state;
    dispatch(updatePagination({ pageNumber: 1, pageToken: null }));
    const isSingleCard = false;
    dispatch(fetchCardsData({ search, isSingleCard, searchBarState, currPageToken }));
  };

  const handleClick = async (e: React.SyntheticEvent) => {
    const targetCardID = (e.target as HTMLElement).getAttribute('data-id');
    if (targetCardID === 'detail-button') return;
    const cardID = e.currentTarget.getAttribute('data-id') || '';
    dispatch(toggleModal(true));
    const isSingleCard = true;
    dispatch(fetchModalCardData({ cardID, isSingleCard }));
  };

  const handleModalClose = (e: React.SyntheticEvent) => {
    const target = e.target as HTMLElement;
    const wrapper = (e.currentTarget as HTMLElement).firstChild as HTMLElement;
    const isWrapper = target === wrapper || wrapper.contains(target);
    const isCloseButton = target.classList.contains('close-button__img');
    if (isWrapper && !isCloseButton) {
      return null;
    }
    dispatch(toggleModal(false));
    dispatch(updateModal({ isModalLoaded: false, modalCard: [], hasModalError: false }));
  };

  const handlePagination = async (page: 'next' | 'prev') => {
    const { search, searchBarState, homePageState, pageNumber } = state;
    const { prevPageToken, nextPageToken } = homePageState;
    const currPageToken = page === 'next' ? nextPageToken : prevPageToken;
    const newPageNumber = page === 'next' ? pageNumber + 1 : pageNumber - 1;
    dispatch(updatePagination({ pageNumber: newPageNumber, pageToken: currPageToken }));
    const isSingleCard = false;
    dispatch(fetchCardsData({ search, isSingleCard, searchBarState, currPageToken }));
  };

  const { showModal } = state;
  const { isLoaded, cards, hasError } = state.homePageState;
  const { modalCard, isModalLoaded, hasModalError } = state.modalState;
  let hasMatches = true;
  if (cards) {
    hasMatches = cards.length > 0;
  }

  return (
    <React.Fragment>
      <Header onSearch={handleSearch} />
      <main className="main">
        <div className="wrapper main__wrapper">
          <div className="main__settings-wrapper">
            <h2 className="main__title">Homepage (YouTube Api)</h2>
            <SearchBar />
          </div>
          <Pagination onChange={handlePagination} />
          {!isLoaded && <Loader />}
          {isLoaded && (
            <div className="main__content">
              {!hasMatches && <div className={`no-matches-message`}>Sorry, no matches found</div>}
              <div className="main__cards">
                {cards &&
                  cards.map((item) => <Card onClick={handleClick} card={item} key={item.etag} />)}
              </div>
              {hasError && (
                <div className={`no-matches-message`}>Sorry, we have a problem with api</div>
              )}
              {showModal && (
                <div className="popup is-active" onClick={handleModalClose}>
                  {!isModalLoaded && <Loader />}
                  {isModalLoaded && (
                    <div className="popup__wrapper">
                      {modalCard && <ModalCard card={modalCard as SingleVideoItem} />}
                    </div>
                  )}
                  {hasModalError && (
                    <div className={`no-matches-message`}>Sorry, we have a problem with api</div>
                  )}
                </div>
              )}
              <Pagination onChange={handlePagination} />
            </div>
          )}
        </div>
      </main>
    </React.Fragment>
  );
}
